import { render, staticRenderFns } from "./a-product-locations-list.vue?vue&type=template&id=4b95e2df&scoped=true"
import script from "./a-product-locations-list.vue?vue&type=script&lang=js"
export * from "./a-product-locations-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b95e2df",
  null
  
)

export default component.exports